/**
 * Обработка ошибок Firebase и сети
 */
export const getErrorMessage = (error) => {
  // Проверка на отсутствие интернета
  if (error?.code === 'unavailable' || 
      error?.message?.includes('ERR_INTERNET_DISCONNECTED') ||
      error?.message?.includes('network') ||
      error?.message?.includes('NetworkError') ||
      !navigator.onLine) {
    return 'Нет подключения к интернету. Проверьте ваше интернет-соединение и попробуйте снова.';
  }

  // Ошибки Firebase
  if (error?.code) {
    switch (error.code) {
      case 'permission-denied':
        return 'У вас нет прав для выполнения этого действия.';
      case 'unauthenticated':
        return 'Вы не авторизованы. Пожалуйста, войдите в систему.';
      case 'not-found':
        return 'Запрашиваемый ресурс не найден.';
      case 'already-exists':
        return 'Этот ресурс уже существует.';
      case 'resource-exhausted':
        return 'Превышен лимит запросов. Попробуйте позже.';
      case 'failed-precondition':
        return 'Операция не может быть выполнена в текущем состоянии.';
      case 'aborted':
        return 'Операция была отменена.';
      case 'out-of-range':
        return 'Запрос выходит за допустимые пределы.';
      case 'unimplemented':
        return 'Эта функция еще не реализована.';
      case 'internal':
        return 'Внутренняя ошибка сервера. Попробуйте позже.';
      case 'unavailable':
        return 'Сервис временно недоступен. Попробуйте позже.';
      case 'data-loss':
        return 'Произошла потеря данных.';
      case 'deadline-exceeded':
        return 'Превышено время ожидания. Попробуйте снова.';
      default:
        return error.message || 'Произошла неизвестная ошибка.';
    }
  }

  // Если есть сообщение об ошибке
  if (error?.message) {
    return error.message;
  }

  // Общая ошибка
  return 'Произошла ошибка. Попробуйте снова.';
};

/**
 * Проверка наличия интернет-соединения
 */
export const isOnline = () => {
  return navigator.onLine;
};

/**
 * Обработка ошибок с логированием
 */
export const handleError = (error, context = '') => {
  console.error(`Error in ${context}:`, error);
  
  const message = getErrorMessage(error);
  
  return {
    message,
    isNetworkError: !navigator.onLine || 
                    error?.code === 'unavailable' ||
                    error?.message?.includes('ERR_INTERNET_DISCONNECTED'),
    originalError: error
  };
};


